import { mdiFileOutline, mdiHomeOutline } from '@mdi/js'

/* eslint-disable */
// prettier-ignore
export default [
  { header: 'Заявки' },

  { title: 'Home', icon: mdiHomeOutline, to: 'upcoming' },
  { title: 'Second Page', icon: mdiFileOutline, to: 'home' },
]
